<template>
    <div class="main-box" v-loading="loading">
        <NavBar title="职位详情"></NavBar>
        <div class="container" v-if="!empty">
            <div class="header">
                <div class="title" v-html="post.postName"></div>
                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>
                <div class="subtitle">
                    <span class="item" v-if="post.org" v-html="'招聘公司：' + post.org.orgName"></span>
                    <span class="item" v-if="post.postType" v-html="'岗位类型：' + post.postType.postTypeName"></span>
                </div>
                <div class="subtitle" v-if="post.area && post.area.areaName" v-html="'工作地点：' + post.area.areaName"></div>
                <div class="subtitle" v-if="post.demandNumber" v-html="'招聘人数：' + post.demandNumber + '人'"></div>
            </div>
            <div class="body">
                <div class="title" v-if="post.duty.length !== 0">工作职责：</div>
                <p class="detailed" v-for="text of post.duty" :key="text" v-html="text"></p>
                <div class="title" v-if="post.requirement.length !== 0">任职要求：</div>
                <p class="detailed" v-for="text of post.requirement" :key="text" v-html="text"></p>
            </div>
        </div>
        <div class="footer" v-if="!empty">
            <el-button type="primary" style="width:100%" @click="imageShow = true">推荐岗位</el-button>
        </div>
        <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！" v-if="empty">
            <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
        </el-empty>
        <QRCodeImage v-model="imageShow" :url="qrcodeUrl" />
    </div>
</template>
<script>
import NavBar from './components/NavBar.vue';
import QRCodeImage from '@/components/QRCodeImage.vue';
import api from '@/api';
export default {
    name: 'MCampus',
    components: { NavBar, QRCodeImage },
    data() {
        return {
            empty: false,
            showTotal: true,
            loading: false,
            post: { duty: [], requirement: [] },
            imageShow: false,
            qrcodeUrl: ''
        };
    },
    created() {
        // if (!this.$store.state.promoterId) {
        //     this.$router.push('/m/recommendindex');
        //     return;
        // }
        this.getDetailByPostId(this.$route.params.id);
    },
    methods: {
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty.split(/[(\r\n)\r\n]+/);
            res.data.requirement = res.data.requirement.split(/[(\r\n)\r\n]+/);
            this.post = res.data;
            this.qrcodeUrl = '/m/recommendedjob?promoterId=' + this.$store.state.promoterId + '&selected=' + res.data.postId;
        },
        // 查看更多岗位点击
        otherPostClick() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    .container {
        width: 100%;
        overflow: auto;
        position: absolute;
        top: 56px;
        bottom: 61px;
        box-sizing: border-box;
        padding: 15px 20px 20px 20px;
        background: #fff;
        .header {
            padding-bottom: 5px;
            border-bottom: 3px solid #eee;
            .title {
                line-height: 24px;
                font-size: 20px;
                color: #222831;
                margin-bottom: 8px;
                font-weight: 600;
            }
            .subtitle {
                font-size: 14px;
                color: #89909e;
                font-weight: 400;
                margin: 5px 0;
                .item {
                    padding: 0 10px;
                    border-right: 1px solid #dddfe3;
                }
                .item:first-child {
                    padding-left: 0;
                }
                .item:last-child {
                    border-right: none;
                }
            }
            .salary {
                color: #ff6b6b;
                font-size: 18px;
                line-height: 20px;
                margin-bottom: 5px;
                font-weight: 600;
            }
        }
        .body {
            .title {
                margin-top: 15px;
                margin-bottom: 9px;
                font-size: 16px;
                color: #222831;
            }
            .detailed {
                color: #a2a4a8;
                font-size: 14px;
                white-space: pre-wrap;
                margin: 0;
            }
        }
    }
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        box-sizing: border-box;
        background: #fff;
        border-top: 1px solid #eee;
        padding: 10px 20px;
    }
}
.qrcode {
    width: 200px;
    background: #fff;
    text-align: center;
    padding-bottom: 10px;
    font-weight: 600;
    .img {
        width: 100%;
    }
}
</style>
